export default "__VITE_ASSET__DsnNXDEg__"